
























import { defineComponent, ref } from '@vue/composition-api';
import CIconArrowTableUp from '@/components/icons/icon-arrow-table-up.component.vue';
import CIconArrowTableDown from '@/components/icons/icon-arrow-table-down.component.vue';

export default defineComponent({
  name: 'cTableHead',
  components: {
    CIconArrowTableUp,
    CIconArrowTableDown,
  },
  props: {
    columns: {
      type: Array,
      required: true,
    },
    sortable: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(_, context) {
    const sort = ref('');
    const sortLabels = ref([ 'edit', 'Web page', 'Comment' ]);
    const handleArrowClick = (name: string, direction: string) => {
      if (sort.value === `${name}_${direction}`) {
        sort.value = '';
      } else {
        sort.value = `${name}_${direction}`;
      }

      context.emit('handle-sort', sort.value);
    };

    return {
      sort,
      sortLabels,
      handleArrowClick,
    };
  },
});
